module.exports = __webpack_public_path__ + "img/install.9d7b34b1.png";